import React, { useRef, useState } from "react";

import { Box, Button, Typography, Card, CardContent } from "@material-ui/core";

import {
  CloudUploadOutlined,
  ImageOutlined,
  DeleteOutline,
} from "@material-ui/icons";

export default function ImageUploader({
  title,
  value,
  onChange,
  removeDisable,
}) {
  const inputRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);

  const handleFile = (file) => {
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("فایل باید تصویر باشد");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("حداکثر حجم فایل 5MB است");
      return;
    }

    onChange({
      file,
      preview: URL.createObjectURL(file),
    });
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];
    handleFile(file);
  };

  const removeImage = () => {
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <Card
      elevation={0}
      style={{
        borderRadius: 16,
        border: "1px solid #EEF2F7",
        overflow: "hidden",
      }}
    >
      <CardContent>
        {/* Title */}
        <Typography
          style={{
            fontWeight: 700,
            marginBottom: 12,
            fontSize: 14,
            color: "#111827",
          }}
        >
          {title}
        </Typography>

        {/* Upload Area */}
        {!value ? (
          <Box
            onClick={() => inputRef.current.click()}
            onDragOver={(e) => {
              e.preventDefault();
              setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
            style={{
              border: "2px dashed",
              borderColor: isDragging ? "#22C55E" : "#CBD5E1",
              borderRadius: 14,
              padding: 25,
              textAlign: "center",
              cursor: "pointer",
              background: isDragging ? "#F0FDF4" : "#F9FAFB",
              transition: "0.2s",
            }}
          >
            <CloudUploadOutlined
              style={{
                fontSize: 40,
                color: isDragging ? "#22C55E" : "#94A3B8",
              }}
            />

            <Typography
              style={{
                marginTop: 10,
                fontSize: 13,
                color: "#64748B",
              }}
            >
              تصویر را اینجا رها کنید یا کلیک کنید
            </Typography>

            <Typography
              style={{
                marginTop: 5,
                fontSize: 11,
                color: "#94A3B8",
              }}
            >
              فرمت: JPG, PNG — حداکثر 5MB
            </Typography>

            <input
              ref={inputRef}
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleFile(e.target.files[0])}
              disabled={removeDisable}
            />
          </Box>
        ) : (
          <Box
            style={{
              textAlign: "center",
            }}
          >
            {/* Preview */}
            <Box
              style={{
                position: "relative",
                display: "inline-block",
              }}
            >
              <img
                src={value.preview}
                alt="preview"
                style={{
                  width: "100%",
                  maxWidth: 260,
                  borderRadius: 12,
                  border: "1px solid #E5E7EB",
                }}
              />

              {!removeDisable && (
                <Button
                  onClick={removeImage}
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    minWidth: 36,
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    background: "#EF4444",
                    color: "#fff",
                  }}
                  disabled={removeDisable}
                >
                  <DeleteOutline style={{ fontSize: 18 }} />
                </Button>
              )}
            </Box>

            {/* Status */}
            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <ImageOutlined
                style={{
                  fontSize: 18,
                  color: "#22C55E",
                  marginLeft: 6,
                }}
              />

              <Typography
                style={{
                  fontSize: 12,
                  color: "#16A34A",
                }}
              >
                تصویر با موفقیت انتخاب شد
              </Typography>
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
